import { AfterViewInit, Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-survey-available-dialog",
  templateUrl: "./survey-available-dialog.component.html",
  styleUrls: ["./survey-available-dialog.component.scss"],
})
export class SurveyAvailableDialogComponent implements OnInit, AfterViewInit {
  @Input() title = "";
  @Input() msg = "";
  onSubmitCallback = () => {};
  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {}

  onSubmit() {
    this.onSubmitCallback();
  }
}
